import { DatePipe } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AdminIconComponent, AdminTableComponent } from '../../admin';
import {
  buildAssignedTaskDetailQuery,
  buildAssignedTaskDetailRoute,
  entityInitials,
  isDisplayableAssignedTask,
  taskDueUrgency,
  type AssignedTaskListItem,
} from '../../models/assigned-task.models';
import { CrmTaskPriorityBadgeComponent } from './crm-task-priority-badge.component';
import { CrmTaskStatusBadgeComponent } from './crm-task-status-badge.component';

@Component({
  selector: 'app-crm-assigned-tasks-table',
  standalone: true,
  imports: [
    DatePipe,
    RouterLink,
    AdminTableComponent,
    AdminIconComponent,
    CrmTaskPriorityBadgeComponent,
    CrmTaskStatusBadgeComponent,
  ],
  templateUrl: './crm-assigned-tasks-table.component.html',
  styleUrl: './crm-assigned-tasks-table.component.scss',
})
export class CrmAssignedTasksTableComponent {
  readonly tasks = input.required<AssignedTaskListItem[]>();
  readonly compact = input(false);

  readonly visibleTasks = computed(() => this.tasks().filter(isDisplayableAssignedTask));

  initials(name: string): string {
    return entityInitials(name);
  }

  dueUrgency(dueAt?: string) {
    return taskDueUrgency(dueAt);
  }

  detailRoute(task: AssignedTaskListItem): string[] {
    return buildAssignedTaskDetailRoute(task);
  }

  detailQuery(task: AssignedTaskListItem): { taskId: string } {
    return buildAssignedTaskDetailQuery(task);
  }
}
